<template>
  <conferencia-list-geral :items="concluidas" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ConferenciaListGeral from './ConferenciaListGeral.vue'

export default {
  name: 'ConferenciaListConcluidas',
  components: { ConferenciaListGeral },
  computed: {
    ...mapGetters('conferencia', ['concluidas']),
  },
  methods: {
    ...mapActions('conferencia', ['getConferencias']),
    async getItems(params) {
      try {
        await this.getConferencias({ params })
      } catch (e) {
        this.errorMessage(e.response.data)
      }
    },
  },
}
</script>
